import html2canvas from "html2canvas";
import React, { useRef, useState } from "react";
import logom from '../../assets/images/icon/amanhmo.svg';
import { uri_img } from "../../assets/utils/http-request";
import { Button, Drawer } from "antd";
import QRCode from "react-qr-code";
import { IdcardOutlined } from "@ant-design/icons";
import './idCard.css';

export const CareCard = (props) => {
  const item = props.data;
  const imgs = useRef(logom);
  const [downloadIDCARD, setDownloadIDCARD] = useState(false);

  const idCard = () => {
      setDownloadIDCARD(true)
  }

  const downloadCard = () => {
      const card = document.querySelector(".modern-id-card");

      // Store original styles
      const originalBoxShadow = card.style.boxShadow;
      const originalBorderRadius = card.style.borderRadius;

      // Temporarily remove shadow and border-radius for clean capture
      card.style.boxShadow = 'none';
      card.style.borderRadius = '0';

      html2canvas(card, { logging: true, letterRendering: 1, allowTaint: false, useCORS: true }).then(canvas => {
        // Restore original styles
        card.style.boxShadow = originalBoxShadow;
        card.style.borderRadius = originalBorderRadius;

        var img   = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.download = `${item.insurance_no}.png`
        link.href = img;

        const triggerDownload = () => {
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        };

        triggerDownload();
      });
  }

  imgs.current = item.pic_name ? `${uri_img}${item.pic_name}` : logom

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
      <>
        <Button onClick={idCard} icon={<IdcardOutlined />} >View ID Card</Button>
        <Drawer title="ID Card Viewer" placement="right" onClose={() => setDownloadIDCARD(false)} open={downloadIDCARD} width={500} extra={
          <Button onClick={downloadCard} type="primary" disabled={item.pic_name? false : true}>
            Download
          </Button>
        }>
          <div className="modern-id-card">
            {/* Header with Logo */}
            <div className="id-card-header">
              <img src={logom} alt="@aman hmo" className="id-card-logo" />
            </div>

            {/* Profile Image */}
            <div className="id-card-profile-section">
              <div className="id-card-profile-image">
                <img 
                  src={imgs.current} 
                  alt={`${item?.first_name?.[0]?.toUpperCase() || ''}${item?.surname?.[0]?.toUpperCase() || ''}`}
                  className="profile-img"
                />
              </div>
            </div>

            {/* Name */}
            <div className="id-card-name-section">
              <h2 className="id-card-name">
                {`${item?.first_name || ''} ${item?.surname || ''}`.toUpperCase()}
              </h2>
            </div>

            {/* Insurance Details */}
            <div className="id-card-details-section">
              <div className="id-card-detail">
                <span className="detail-label">INSURANCE NO:</span>
                <span className="detail-value">{item?.insurance_no || 'N/A'}</span>
              </div>
              <div className="id-card-detail">
                <span className="detail-label">VALID UNTIL:</span>
                <span className="detail-value">{formatDate(props?.policy?.expiry_date)}</span>
              </div>
            </div>

            {/* QR Code */}
            <div className="id-card-qr-section">
              <QRCode
                value={`https://id.amanmedicare.com/verify/?user=${item?.hash}`}
                level='M'
                size={160}
                className="id-card-qr"
                type="image/png"
                bgColor="transparent"
              />
            </div>
          </div>
        </Drawer>
      </>
    
  )
}